/**
 * Validates a value is an abn number.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name abn
 * @memberof combinators
 */
async function validate(value, context) {
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

  // always pass on a null input
  if (value === undefined || value === null || value === '') {
    return Promise.resolve(null);
  }

  // strip non-alphanumeric characters
  const abn = value.toString().replace(/[^a-z\d]/gi, '');

  if (abn.length !== 11) {
    return Promise.resolve(null);
  }

  let sum = 0;
  weights.forEach((weight, position) => {
    const digit = Number(abn[position]) - (position ? 0 : 1);
    sum += weight * digit;
  });

  return Promise.resolve((sum % 89 === 0) ? null : 'abn-invalid');
}

module.exports = validate;
